import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Heart, Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();
  return (
    <section className="py-12 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-br from-emerald-600 to-teal-700 rounded-3xl overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
              <defs>
                <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
                  <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" />
            </svg>
          </div>

          {/* Floating Elements */}
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl" />
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl" />

          <div className="relative px-8 py-16 md:px-16 md:py-20">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Left Content */}
              <div className="text-white">
                <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full mb-6">
                  <Sparkles className="w-4 h-4 mr-2" />
                  <span className="text-sm font-medium">{t('readyToMakeDifference')}</span>
                </div>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                  {t('readyToMakeDifference')}
                </h2>
                <p className="text-lg text-emerald-100 mb-8">
                  {t('ctaSubtitle')}
                </p>
                <div className="flex flex-wrap gap-4">
                  <Link to="/create">
                    <Button size="lg" className="bg-white text-emerald-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-xl shadow-lg">
                      <Heart className="mr-2 w-5 h-5" /> {t('startFundraising')}
                    </Button>
                  </Link>
                  <Link to="/discover">
                    <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl">
                      {t('exploreCampaigns')} <ArrowRight className="ml-2 w-5 h-5" />
                    </Button>
                  </Link>
                </div>
              </div>

              {/* Right Content - Stats Cards */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white">
                  <p className="text-4xl font-bold mb-1">Global</p>
                  <p className="text-emerald-100">Community</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white">
                  <p className="text-4xl font-bold mb-1">Growing</p>
                  <p className="text-emerald-100">Campaigns</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white">
                  <p className="text-4xl font-bold mb-1">Active</p>
                  <p className="text-emerald-100">Donors</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white">
                  <p className="text-4xl font-bold mb-1">Trusted</p>
                  <p className="text-emerald-100">Platform</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
